export interface ImagePreviewSize { width: number; height: number }

const FALLBACK_SIZE: ImagePreviewSize = { width: 1600, height: 1200 }

export function isSvgSource(src: string, mimeType = ''): boolean {
  const value = String(src || '').trim()
  return /^image\/svg\+xml(?:;|$)/i.test(String(mimeType || '').trim())
    || /^data:image\/svg\+xml(?:[;,]|$)/i.test(value)
    || /\.svg(?:$|[?#])/i.test(value)
}

export function nextPreviewRotation(rotation: number): 0 | 90 {
  return Math.abs(rotation % 180) === 90 ? 0 : 90
}

export function rotatedFitRatio(stageWidth: number, stageHeight: number, sourceWidth: number, sourceHeight: number): number {
  if (stageWidth <= 0 || stageHeight <= 0 || sourceWidth <= 0 || sourceHeight <= 0) return 1
  const unrotatedFit = Math.min(1, stageWidth / sourceWidth, stageHeight / sourceHeight)
  const rotatedFit = Math.min(1, stageWidth / sourceHeight, stageHeight / sourceWidth)
  return unrotatedFit > 0 ? rotatedFit / unrotatedFit : 1
}

export function resolveImagePreviewSize(src: string, width?: number, height?: number): Promise<ImagePreviewSize> {
  if (Number(width) > 0 && Number(height) > 0) return Promise.resolve({ width: Number(width), height: Number(height) })
  return new Promise((resolve) => {
    const image = new Image()
    image.onload = () => resolve({ width: image.naturalWidth || FALLBACK_SIZE.width, height: image.naturalHeight || FALLBACK_SIZE.height })
    image.onerror = () => resolve(FALLBACK_SIZE)
    image.src = src
  })
}
